export const textEng=[
"How to participate?",
"Select and click on a Member of Parliament below, who has yet to reply.",
"Copy text and headline found on the Member of Parliament’s page and send it to the Member of Parliament from your personal email address. ",
"If enough people ask the question, together we can get the Members of Parliament to answer and take responsibility for our common future.",
"You can read the email message to the Member of Parliament ",
"here.",
" of 349 Members of Parliament have answered"  
]